import { NgModule } from '@angular/core';

import { OddsComparerFactory } from '@frontend/sports/odds/feature';
import { EffectsModule } from '@ngrx/effects';

import BetBuilderEffects from '../bet-builder/bet-builder-effects';
import AddRemoveEffects from './effects/add-remove-effects';
import { GroupedPicksEffects } from './effects/grouped-picks.effects';
import GroupsInternalPicksUpdateEffects from './effects/groups-legs-internal-updates.effects';
import { LastPickErrorEffects } from './effects/last-pick-error-effects';
import PickUpdateEffects from './effects/pick-update-effects';
import PushEffects from './effects/push-effects';
import BetslipPickFactory from './factory/betslip-pick.factory';
import OptionPickFactory from './factory/option-pick.factory';
import ParticipantPickFactory from './factory/participant-pick.factory';
import V1PickFactory from './factory/v1-pick.factory';
import { BetslipMarketSubTypeLogoService } from './services/betslip-market-sub-type-logo.service';
import { BetslipPicksRequestBuilderService } from './services/betslip-pick-request-builder.service';
import BetslipPickSubscriptionService from './services/betslip-pick-subscription.service';
import BetslipPickUtilsService from './services/betslip-pick-utils.service';
import BetslipPicksStateStorageService from './services/betslip-picks-state-storage.service';
import PickRefresherService from './services/pick-refresher.service';

@NgModule({
    imports: [
        EffectsModule.forFeature([
            BetBuilderEffects,
            AddRemoveEffects,
            PushEffects,
            PickUpdateEffects,
            GroupedPicksEffects,
            GroupsInternalPicksUpdateEffects,
            LastPickErrorEffects,
        ]),
    ],
    providers: [
        V1PickFactory,
        ParticipantPickFactory,
        OptionPickFactory,
        BetslipPickFactory,
        BetslipPicksRequestBuilderService,
        OddsComparerFactory,
        BetslipPickUtilsService,
        BetslipPickSubscriptionService,
        PickRefresherService,
        BetslipPicksStateStorageService,
        BetslipMarketSubTypeLogoService,
    ],
})
export default class BetslipPicksModule {}
